import { useSelector } from 'react-redux';
import { getUser } from '../redux/auth/auth-selectors';

export const IS_ADMIN = () => {
  const auth = useSelector(getUser) || {};
  return auth.role === 'root' || auth.role === 'admin';
};
